import { Routes, Route } from "react-router-dom";
import { Login } from "../Pages/Login";
import { Home } from "../Pages/Home";
import { HomeProvider } from "../Context/ContextHome";
import { LoginProvider } from "../Context/ContextLogin";
import { AdminProvider } from "../Context/ContextAdmin";
import { Admin } from "../Pages/admin";
import { AdminElevatorias } from "../Pages/admin/elevatoria";
import { AdminUsuarios } from "../Pages/admin/usuarios";
import { ElevatoriaProvider } from "../Context/contextElevatoria";
import { Elevatorias } from "../Pages/Elevatoria";
import { NotFound } from "../Pages/notFound";
import { Grade } from "../Pages/Grade";
import { GradeProvider } from "../Context/ContextGrade";

export const RoutersMain = () => {
  return (
    <Routes>
      <Route element={<HomeProvider />}>
        <Route path="/" element={<Home />} />
        <Route element={<AdminProvider />}>
          <Route path="/admin" element={<Admin />} />
          <Route
            path="/admin/lista/elevatorias"
            element={<AdminElevatorias />}
          />
          <Route path="/admin/lista/usuarios" element={<AdminUsuarios />} />
        </Route>
        <Route element={<ElevatoriaProvider />}>
          <Route path="/elevatoria/:codigo_estacao" element={<Elevatorias />} />
        </Route>
        <Route element={<GradeProvider />}>
          <Route path="/grade/:codigo_estacao" element={<Grade />} />
        </Route>
      </Route>
      <Route element={<LoginProvider />}>
        <Route path="/Login" element={<Login />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
